export default __webpack_public_path__ + "static/media/Icon simple-twitter.a803a369.svg";